import { motion } from "framer-motion";

export const SidebarBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
      {/* Floating Circles */}
      <motion.svg
        className="absolute -top-8 -left-8 w-24 h-24 text-white/10"
        viewBox="0 0 100 100"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1, delay: 0.2 }}
      >
        <circle cx="50" cy="50" r="45" fill="currentColor" />
      </motion.svg>

      <motion.svg
        className="absolute bottom-32 -right-6 w-20 h-20 text-white/5"
        viewBox="0 0 100 100"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1, delay: 0.4 }}
      >
        <circle cx="50" cy="50" r="45" fill="currentColor" />
      </motion.svg>

      {/* Floating Hexagon */}
      <motion.svg
        className="absolute top-1/4 right-2 w-14 h-14 text-white/10"
        viewBox="0 0 100 100"
        initial={{ rotate: 0, opacity: 0 }}
        animate={{ rotate: 360, opacity: 1 }}
        transition={{ duration: 20, repeat: Infinity, ease: "linear", opacity: { duration: 1 } }}
      >
        <polygon 
          points="50,5 95,27.5 95,72.5 50,95 5,72.5 5,27.5" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2"
        />
      </motion.svg>

      {/* Animated Lines */}
      <motion.svg
        className="absolute top-1/2 -left-4 w-32 h-32 text-white/5"
        viewBox="0 0 100 100"
        initial={{ pathLength: 0, opacity: 0 }}
        animate={{ pathLength: 1, opacity: 1 }}
        transition={{ duration: 2, delay: 0.5 }}
      >
        <motion.path
          d="M10 50 Q 30 20, 50 50 T 90 50"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 2, repeat: Infinity, repeatType: "reverse" }}
        />
      </motion.svg>

      {/* Floating Squares */}
      <motion.svg
        className="absolute bottom-24 left-4 w-10 h-10 text-white/10"
        viewBox="0 0 100 100"
        animate={{ 
          y: [0, -15, 0],
          rotate: [0, 45, 0]
        }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
      >
        <rect x="20" y="20" width="60" height="60" fill="currentColor" />
      </motion.svg>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/10" />

      {/* Animated Ring */}
      <motion.svg
        className="absolute top-2/3 right-0 w-16 h-16 text-white/10"
        viewBox="0 0 100 100"
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.5, delay: 0.3 }}
      >
        <circle cx="50" cy="50" r="40" fill="none" stroke="currentColor" strokeWidth="4" />
        <motion.circle 
          cx="50" 
          cy="50" 
          r="30" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2"
          initial={{ rotate: 0 }}
          animate={{ rotate: 360 }}
          transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
        />
      </motion.svg>

      {/* Triangle */}
      <motion.svg
        className="absolute bottom-1/2 -left-2 w-12 h-12 text-white/10"
        viewBox="0 0 100 100"
        animate={{ 
          y: [0, 10, 0],
        }}
        transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
      >
        <polygon points="50,10 90,90 10,90" fill="currentColor" />
      </motion.svg>
    </div>
  );
};

export default SidebarBackground;
